import { createStrictContext } from 'envoc-strict-context';
import { MutableRefObject } from 'react';

export const [ShadowScrollContextProvider, useShadowScrollContext] =
  createStrictContext<MutableRefObject<HTMLDivElement | null>>();
